const antdConfig = {
  token: {
    boxShadowSecondary: "var(--hs-box-shadow-secondary)",
  },
  components: {
    Menu: {
      itemSelectedBg: "var(--hs-light-violet, #EFEEFF)",
      itemActiveBg: "var(--hs-light-violet, #EFEEFF)",
      itemSelectedColor: "var(--hs-violet)",
      itemColor: "var(--hs-dark-grey-2)",
      itemHoverColor: "var(--hs-dark-grey-2)",
      itemHoverBg: "var(--hs-light-grey, #F5F5F5)",
      subMenuItemBg: "var(--hs-plain-white)",
      itemHeight: 36,
    },
    Input: {
      activeBorderColor: "var(--hs-violet)",
      hoverBorderColor: "var(--hs-outline-grey)",
      colorBgContainer: "transparent",
      colorBorder: "var(--hs-outline-grey)",
      colorError: "var(--hs-red)",
      colorErrorBorder: "var(--hs-red)",
      colorErrorBorderHover: "var(--hs-red)",
      colorTextPlaceholder: "var(--hs-placeholder-grey)",
      colorBgContainerDisabled: "var(--hs-plain-white)",
    },
    Pagination: {
      colorPrimary: "var(--hs-violet)",
      colorPrimaryHover: "var(--hs-violet-hover)",
    },
    Select: {
      colorBorder: "var(--hs-border-grey)",
      colorPrimary: "var(--hs-violet)",
      colorPrimaryHover: "var(--hs-violet)",
      activeBorderColor: "var(--hs-violet)",
      activeShadow: "none",
      colorError: "var(--hs-red)",
      colorErrorBorder: "var(--hs-red)",
      colorErrorBorderHover: "var(--hs-red)",
      colorTextPlaceholder: "var(--hs-placeholder-grey)",
      popupBorderRadius: 8,
      controlItemBgHover: "var(--hs-light-grey, #F5F5F5)",
      optionSelectedBg: "var(--hs-light-violet, #EFEEFF)",
      optionSelectedColor: "var(--hs-violet)",
      colorBgContainerDisabled: "var(--hs-plain-white)",
    },
    Checkbox: {
      colorPrimary: "var(--hs-violet)",
      colorPrimaryHover: "var(--hs-violet-hover)",
      colorBorder: "var(--hs-button-outline-light-grey)",
      colorBorderSecondary: "var(--hs-violet) !important",
      borderRadiusSM: "2px",
    },
    Tabs: {
      colorPrimary: "var(--hs-violet)",
      colorPrimaryHover: "var(--hs-violet-hover)",
    },
    Table: {
      colorPrimary: "var(--hs-violet)",
      colorPrimaryHover: "var(--hs-violet-hover)",
      rowSelectedBg: "var(--hs-light-violet)", // light violet for selected rows
      rowSelectedHoverBg: "var(--hs-light-violet)", // light violet for selected rows
    },
    Upload: {
      colorPrimary: "var(--hs-violet)",
      colorPrimaryHover: "var(--hs-violet-hover)",
      colorBorder: "var(--hs-container-outline-grey)",
      colorBorderHover: "var(--hs-violet)",
    },
    DatePicker: {
      colorPrimary: "var(--hs-violet)",
      colorPrimaryHover: "var(--hs-violet-hover)",
      colorBorder: "var(--hs-container-outline-grey)",
    },
    Button: {
      colorPrimary: "var(--hs-violet)",
      colorPrimaryHover: "var(--hs-violet-hover)",
      colorBorder: "2px solid var(--hs-container-outline-grey)",
    },
    Radio: {
      colorPrimary: "var(--hs-violet)",
      dotSize: 10,
    },
    TreeSelect: {
      colorPrimary: "var(--hs-violet)",
      colorPrimaryHover: "var(--hs-violet)",
    },
    Dropdown: {
      colorText: "var(--hs-color-BlackRussian)",
    }
  },
};

export default antdConfig;
